export const getIsExpired = (expMonth: string, expYear: string): boolean => {
  const month = Number(expMonth);
  const year = Number(expYear);

  if (!month || !year) {
    return false;
  }

  const expiryDate = new Date(year, month, 0, 23, 59, 59, 999);

  return expiryDate.getTime() < Date.now();
};

export const formatExpiryLabel = (
  expMonth: string,
  expYear: string
): string => {
  return `${+expMonth < 10 ? '0' : ''}${expMonth}/${expYear.slice(2)}`;
};

export const getStripeElementOptions = (placeholder?: string) => ({
  placeholder,
  style: {
    base: {
      color: '#d9d9d9',
      fontFamily:
        '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '20px',
      '::placeholder': {
        color: '#999999',
      },
    },
    invalid: {
      color: '#f43f36',
    },
  },
});
